__turbopack_context__.v({
  "brand": "studio-auth-module__nmXN8q__brand",
  "card": "studio-auth-module__nmXN8q__card",
  "eyebrow": "studio-auth-module__nmXN8q__eyebrow",
  "form": "studio-auth-module__nmXN8q__form",
  "language": "studio-auth-module__nmXN8q__language",
  "login": "studio-auth-module__nmXN8q__login",
  "loginCard": "studio-auth-module__nmXN8q__loginCard",
  "loginFooter": "studio-auth-module__nmXN8q__loginFooter",
  "notice": "studio-auth-module__nmXN8q__notice",
  "primary": "studio-auth-module__nmXN8q__primary",
  "secondary": "studio-auth-module__nmXN8q__secondary",
  "shell": "studio-auth-module__nmXN8q__shell",
});
